import classNames from "classnames";

import styles from "./index.module.scss";

type PropsType = {
  name: string;
  userRole: string;
  size: "small" | "medium" | "large";
};

const ProfileIcon = ({ name, userRole, size }: PropsType) => {
  const initials = name?.match(/\b(\w)/g)?.join("");

  return (
    <div
      className={classNames(styles.box, styles.default, {
        [styles.authorizer]: userRole === "Authorizer" || userRole === "Motion Support",
        [styles.salesRep]: userRole === "Sales Rep",
        [styles.admin]: userRole === "Administrator" || userRole === "Location Admin",
        [styles.small]: size === "small",
        [styles.medium]: size === "medium",
        [styles.large]: size === "large",
      })}
    >
      {initials}
    </div>
  );
};

export default ProfileIcon;
